<cdk-accordion class="example-accordion">
    @for (item of sections; track item; let index = $index) {
        <cdk-accordion-item
            #accordionItem="cdkAccordionItem"
            tabindex="0"
            [expanded]="index === 0"
            [attr.id]="'accordion-header-' + index"
            [attr.aria-expanded]="accordionItem.expanded"
            [attr.aria-controls]="'accordion-body-' + index">
            <div
                role="button"
                [attr.id]="'accordion-button-' + index"
                class="flex justify-between items-center group text-gray-500 hover:text-gray-700 border-gray-200 whitespace-nowrap border-b-2 font-medium text-sm"
                [ngClass]='{
                  "border-gray-300": accordionItem.expanded,
                  "border-gray-200": !accordionItem.expanded
                }'
                (click)="accordionItemClick(accordionItem, 'accordion-button-' + index)">
                <div
                    class="border-b-2 py-3 -mb-[2px] uppercase px-2"
                    [ngClass]='{
                  "border-primary-500 text-primary-600": accordionItem.expanded,
                  "border-transparent text-gray-500 group-hover:border-primary-300": !accordionItem.expanded
                 }'>{{ item.title }}
                </div>
                <div class="px-2">
                    <button
                        class="text-sm font-medium text-gray-600 hover:text-gray-900"
                    >
                        <fa-icon [icon]="chevronDown" class="text-gray-500 pr-1"
                                 [rotate]="accordionItem.expanded ? 180 : undefined"></fa-icon>
                    </button>
                </div>
            </div>
            <div class="transition-opacity overflow-hidden"
                 [ngClass]="accordionItem.expanded ? 'opacity-100' : 'max-h-0 opacity-0'">
                <div
                    class="px-2 py-4 prose max-w-none"
                    role="region"
                    [attr.id]="'accordion-body-' + index"
                    [attr.aria-labelledby]="'accordion-header-' + index">
                    @if (item.title === deliveryReturnsTitle) {
                        <p>
                            All parcels are sent on a trackable service. The information below is for UK deliveries. For
                            international
                            deliveries, please see our <a [routerLink]="['/a', 'delivery-information']">delivery
                            information pages.</a>
                        </p>
                        @if (isLargeLetterShipping) {
                            <div class="font-bold uppercase">Letterbox service</div>
                            <p>This item is included in our letterbox service. If an order contains only letter box
                                items the following
                                charges will apply. If you add larger items, not included in the letterbox service, your
                                shipping will
                                revert to our standard shipping charges.</p>
                            <table>
                                <thead>
                                <tr>
                                    <th colspan="2">Standard shipping 1-3 working days</th>
                                </tr>
                                </thead>
                                <tbody>
                                <tr>
                                    <td>Orders under £25</td>
                                    <td>£3.00</td>
                                </tr>
                                <tr>
                                    <td>Orders over £25</td>
                                    <td>FREE</td>
                                </tr>
                                </tbody>
                                <thead>
                                <tr>
                                    <th colspan="2">Express Shipping Next Working Day</th>
                                </tr>
                                </thead>
                                <tbody>
                                <tr>
                                    <td>Orders under £25</td>
                                    <td>£5.50</td>
                                </tr>
                                <tr>
                                    <td>Orders over £25</td>
                                    <td>£2.50</td>
                                </tr>
                                </tbody>
                            </table>
                            <div class="font-bold uppercase">For non letterbox items:</div>
                        }
                        <table class="mt-2">
                            <thead>
                            <tr>
                                <th colspan="2">Standard shipping 1-3 working days</th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr>
                                <td>Orders under £45</td>
                                <td>£4.50</td>
                            </tr>
                            <tr>
                                <td>Orders over £45</td>
                                <td>FREE</td>
                            </tr>
                            </tbody>
                            <thead>
                            <tr>
                                <th colspan="2">Express Shipping Next Working Day</th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr>
                                <td>Orders under £45</td>
                                <td>£7.00</td>
                            </tr>
                            <tr>
                                <td>Orders over £45</td>
                                <td>£2.50</td>
                            </tr>
                            </tbody>
                        </table>
                        <p>See our <a [routerLink]="['/a', 'returns']">Returns policy</a></p>
                    } @else if (item.content) {
                        <div [innerHTML]="item.content"></div>
                    } @else if (item.specs?.length) {
                        <div class="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-2 gap-4">
                            @for (spec of item.specs; track spec; let specIndex = $index) {
                                <div class="mt-4">
                                    <div class="text-gray-500 text-sm">{{ spec.name }}</div>
                                    <div class="text-gray-600 text-sm font-medium flex flex-wrap gap-2">
                                        @for (value of spec.values; track value) {
                                            <div class="border rounded-full px-2 inline-flex min-w-10">
                                                {{ value }}
                                            </div>
                                        }
                                    </div>
                                </div>
                            }
                        </div>
                    }
                </div>
            </div>
        </cdk-accordion-item>
    }
</cdk-accordion>
